import { SimCardStates } from '@racemap/sdk/schema/simCard';
import { Modal, Typography } from 'antd';
import type { Immutable } from 'immer';
import type { FC } from 'react';
import { toast } from 'react-toastify';
import { useStore } from 'src/store/reducers';
import type { ManagedTracker } from 'src/store/trackers/trackers_reducers';
import { useTrackersForAction } from '../../../lib/customHooks';

const { Text } = Typography;

export const TerminateSimCardsButton: FC = () => {
  const trackersToUse = useTrackersForAction();
  const { terminateSimCards } = useStore((s) => s.trackers.actions);

  if (trackersToUse == null) return <></>;
  const trackersWithActivSims = trackersToUse.filter(isActivSimCard);
  const handleClick = async () => {
    if (trackersWithActivSims.length === 0) return;

    Modal.confirm({
      title: 'Are you sure you want to terminate the SIM cards?',
      content: (
        <Text>
          This action will terminate the SIM cards for{' '}
          <Text strong>{trackersWithActivSims.length}</Text> of the selected trackers. Terminated
          SIM cards can't receive SMS or open a data connection.
        </Text>
      ),
      onOk: async () => {
        const numTerminatedSimCards = await terminateSimCards(
          trackersWithActivSims.map((tracker) => tracker.id),
        );
        toast.success(`Successfully terminate ${numTerminatedSimCards} SIM cards!`);
      },
    });
  };

  return (
    <Text
      onClick={() => handleClick()}
      onKeyDown={({ key }) => key === 'Enter' && handleClick()}
      disabled={trackersWithActivSims.length === 0}
    >
      Terminate
    </Text>
  );
};

export function isActivSimCard(tracker: Immutable<ManagedTracker>): boolean {
  return tracker.simCard != null && tracker.simCard.status === SimCardStates.AKTIV;
}
